export default __webpack_public_path__ + "img/cdcf5bc487c725d69b84ddbf18624aba.png";